import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['section']

  expandAll(e) {
    if (e) e.preventDefault()
    this.sectionTargets.forEach((d) => { d.open = true })
  }

  collapseAll(e) {
    if (e) e.preventDefault()
    this.sectionTargets.forEach((d) => { d.open = false })
  }
}
